<template>
    <!-- Start Footer Area -->
    <footer class="footer-area bg-f7fafd">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <div class="logo">
                            <a href="/">
                                <img src="../../assets/img/logo.png" alt="logo" />
                            </a>
                        </div>
                        <p>WB SOFTWARES is a Bangladesh based software and other IT consulting company which focuses on building fast, secure and reliable solutions for increasing your productivity.</p>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget pl-5">
                        <h3>Company</h3>
                        <ul class="list">
                            <li><router-link to="/">Home</router-link></li>
                            <li><router-link to="/about">About</router-link></li>
                            <li><router-link to="/service">Services</router-link></li>
                            <li><router-link to="/service-glance">Services View</router-link></li>
                            <li><router-link to="/privacy">Privacy Policy</router-link></li>
                            <li><router-link to="/contact">Contact</router-link></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h3>Blogs</h3>
                        <ul class="list">
                            <li><router-link to="/blog-details/NeedApps">Need an app?</router-link></li>
                            <li><router-link to="/blog-details/NeedWebSide">Need an online website?</router-link></li>
                            <li><router-link to="/blog-details/NeedDigitalMarketing">Need digital marketing?</router-link></li>
                            <li><router-link to="/blog-details/WhyECommerce">Need an eCommerce?</router-link></li>
                            <li><router-link to="/blog-details/WhyRestudent">Need a software?</router-link></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h3>Address</h3>
                        
                        <ul class="footer-contact-info">
                            <li><feather type="map-pin"></feather> House# 375, Flat# 3B, Road# 28, New DOHS Mohakhali, Dhaka</li>
                            <li><feather type="mail"></feather> Email: <a href="mailto:mail@wbsoftwares.com">mail@wbsoftwares.com </a></li>
                            <li><feather type="phone-call"></feather> Phone: <a href="callto:+8801774444000">+8809696863000</a></li>
                            <li><feather type="phone-call"></feather> Phone: <a href="callto:+8801774444000">+8801774444000</a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-12 col-md-12">
                    <div class="copyright-area">
                        <p>Copyright &copy;2021-2026 WB SOFTWARES. All Rights Reserved</p>
                    </div>
                </div>
            </div>
        </div>

        <img src="../../assets/img/map.png" class="map" alt="map">
        <div class="shape1"><img src="../../assets/img/shape1.png" alt="shape"></div>
        <div class="shape8 rotateme"><img src="../../assets/img/shape2.svg" alt="shape"></div>
        <!-- <div class="go-top"><feather type="arrow-up"></feather></div> -->

        <back-to-top bottom="50px" right="50px">
            <div class="go-top"><feather type="arrow-up"></feather></div>
        </back-to-top>
    </footer>
    <!-- End Footer Area -->
</template>

<script>
import BackToTop from 'vue-backtotop'
export default {
    name: 'Footer',
    components: { BackToTop }
}
</script>